
// Import all flag assets globally
const flagModules = import.meta.glob('/src/assets/flags/*.svg', { eager: true, import: 'default' });

// Map of normalized country names to their asset paths
const flagMap: Record<string, string> = {};

// Manual overrides for typos in asset filenames or naming differences
const overrides: Record<string, string> = {
    "australia": "Austrailia", // Typo in asset
    "bolivia": "Boliivia", // Typo in asset
    "burkina faso": "Bukina Faso", // Typo in asset
    "czech republic": "Czechia", // Different name
    "dominica": "Dominca", // Typo in asset
    "el salvador": "El Savador", // Typo in asset
    "equatorial guinea": "Equitorial Gineau", // Typo in asset
    "ethiopia": "Ethopia", // Typo in asset
    "french polynesia": "Franch Polynesia", // Typo in asset
    "gibraltar": "Gilbraltar", // Typo in asset
    "guadeloupe": "Gredaloupe", // Typo in asset
    "guernsey": "Guersney", // Typo in asset
    "kyrgyzstan": "Krygzstan", // Typo in asset
    "montenegro": "Montegro", // Typo in asset
    "morocco": "Morroco", // Typo in asset
    "niue": "Nuie", // Typo in asset
    "papua new guinea": "Papau New Guinea", // Typo in asset
    "philippines": "Philipinnes", // Typo in asset
    "saint lucia": "Saint Levis", // Likely typo/mismatch
    "united states": "United States",
    "united kingdom": "United Kingdom",
};

// Populate the flagMap
Object.keys(flagModules).forEach((path) => {
    // Extract filename without extension
    const fileName = path.split('/').pop()?.replace('.svg', '') || '';
    if (fileName) {
        flagMap[fileName.toLowerCase()] = flagModules[path] as string;
    }
});

/**
 * Retrieves the flag image URL for a given country name.
 * @param countryName The name of the country (e.g., "France", "United States")
 * @returns The URL of the flag image, or null if not found.
 */
export const getCountryFlag = (countryName: string | null | undefined): string | null => {
    if (!countryName) return null;

    const normalizedName = countryName.toLowerCase().trim();

    // Check overrides first
    if (overrides[normalizedName]) {
        const overrideName = overrides[normalizedName].toLowerCase();
        if (flagMap[overrideName]) {
            return flagMap[overrideName];
        }
    }

    // Check direct match
    if (flagMap[normalizedName]) {
        return flagMap[normalizedName];
    }

    return null;
};
